import React, { Component } from 'react';
import { connect } from 'react-redux';
import DeliveryMapOptions from '../DeliveryMapOptions/DeliveryMapOptions';
import * as actions from '../../store/actions/index';
import DeliveryMap from '../../components/DeliveryMap/DeliveryMap';
import { MdPlayCircleOutline } from 'react-icons/md';
class Delivery extends Component {
    state = {
        deliveryId: 0,
        state: 'overview'
    }


    componentDidMount () {
        this.props.getDelivery();  
             console.log(React.version);
    }

    componentDidUpdate() {
        if (this.props.delivery && this.props.delivery.deliveryId !== this.state.deliveryId) {
            this.setState({deliveryId: this.props.delivery.deliveryId})
          } 
          console.log(this.props.delivery.deliveryId);
console.log(this.state.deliveryId);
    }
    
    showOverview = () => {

    }

    showDirections = () => {
        
    }

    orderUpdated = () => {

    }
    render () {
        let showSetAvailability = true;
        if (this.props.delivery && this.props.delivery.orders) {
        for (let k in this.props.delivery.orders) {
            if ( this.props.delivery.orders[k].status != 'delivered') {
                showSetAvailability = false;
            }
        }
    }
    else {
        showSetAvailability = true;
    }
  
  
    let deliveryOptions = '';
    if (showSetAvailability) {
        deliveryOptions = <div>
        <DeliveryMapOptions state={this.state} overview={this.showOverview} directions={this.showDirections}/>
    </div>
    }
    
        
        return (
            
            <div style={{"height":"100%"}}>
                <div style={{height:10}}  />
                <div style={{"height":"70%",marginTop:20}}>
                <DeliveryMap id="deliveryMap"
            deliveryId={this.state.deliveryId}  
            key='map' 
            style={{"height":"200"}}
            orderUpdated={this.orderUpdated}
            />

                        {deliveryOptions}
              
                </div>
                
            </div>
                );
    }
}

const mapStateToProps = state => {
    console.log(state);
    return {
        delivery: state.orders.delivery,
        isAuthenticated: state.orders.token !== null,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        getDelivery: () => dispatch(actions.getDelivery())
    }
}


export default connect(mapStateToProps,mapDispatchToProps)(Delivery);


// WEBPACK FOOTER //
// ./src/components/Delivery/Delivery.js